module.exports = __webpack_public_path__ + "img/invalidURL.ac3d516c.png";